import { render, staticRenderFns } from "./ArchiveBatchNumberModal.vue?vue&type=template&id=50605154&"
import script from "./ArchiveBatchNumberModal.vue?vue&type=script&lang=js&"
export * from "./ArchiveBatchNumberModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports